import { IChartContainer } from "../models/base/chart-container.interface";
import { TIChartPointModel } from "../models/data-point/ti-chart-point.model";
import { IComponent } from "./component.interface";

export class ComparisonSymbolLegendsComponent implements IComponent {
    public id = '';
    public isShow = false;

    private element: HTMLElement;
    private comparisonContainerElement: HTMLElement | null = null;
    private controlElement: HTMLElement | null = null;
    private base: IChartContainer;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.controlElement = this.element.findParents('.controls');
        this.comparisonContainerElement = this.element.findFirst('.comparison-container');
        this.base = base;
    }
    
    public show(html: string) {
        this.comparisonContainerElement?.setInnerHtml(html);
        this.controlElement?.addClass('has-comparisons');
        this.base.tiChartSeries.element.findFirst('.highcharts-stocktools-wrapper')?.addClass('has-comparison');
        this.base.tiChartSeries.element.findFirst('.tooltip')?.addClass('has-comparison');
        this.isShow = true;
        setTimeout(() => {
            this.onSymbolClick();
        }, 250);
    }

    public hide() {
        this.controlElement?.removeClass('has-comparisons');
        this.base.tiChartSeries.element.findFirst('.highcharts-stocktools-wrapper')?.removeClass('has-comparison');
        this.base.tiChartSeries.element.findFirst('.tooltip')?.removeClass('has-comparison');
        this.comparisonContainerElement?.setInnerHtml('');
        this.isShow = false;
    }

    public render(xValue: number) {
        if (!this.isShow || !this.base.tiChartSeries || !this.base.tiChartSeries.tiComparisionsData?.length) {
            return;
        }
        
        
        if (this.base.tiChartSeries.chartStyleSettings?.isComparisonSymbolPercentageMode) {
            const primarySymbol =  this.base.tiChartSeries.symbol;
            const point = this.base.tiChartSeries.tiChartPoints.find((x: TIChartPointModel) => x.xValue == xValue) ?? null;
            const value = this.base.tiChartSeries.lastDataPoint ? this.base.tiChartSeries.highChartComparisonBuilder.getPercentageAnnotationText(point) : '';
            
            const textElement = this.comparisonContainerElement?.findFirst('p.' + primarySymbol);
            if (textElement) {
                textElement.innerHTML = `${primarySymbol}: ${value}`;
            }
        }

        for (const tiComparisonData of this.base.tiChartSeries.tiComparisionsData) {
            const point = tiComparisonData.points.find((x: TIChartPointModel) => x.xValue == xValue);
            if (!point) {
                continue;
            }

            const textElement = this.comparisonContainerElement?.findFirst('p.' + tiComparisonData.symbol);
            if (textElement) {
                const displayResult = this.base.tiChartSeries.highChartComparisonBuilder.getCurrentDisplayValue(tiComparisonData, xValue);
                textElement.style.color = `${tiComparisonData.color.toRGB()}`;
                textElement.innerHTML = `${tiComparisonData.symbol}: ${displayResult.percentageChange}`;
            }
        }
    }

    private onSymbolClick() {
        this.comparisonContainerElement?.querySelectorAll('p').forEach((el: HTMLElement) => {
            if (!el.classList.contains('inited')) {
                el.classList.add('inited');
    
                el.addEventListener('click', () => {
                    const primarySymbol =  this.base.tiChartSeries?.symbol ?? '';
                    const symbol = el.dataset.symbol;
                    if (symbol == primarySymbol) {
                        this.base.chartService.requestOpenSymbolLookup(primarySymbol);
                    } else {
                        this.base.chartService.requestOpenComparisonSymbolLookup(symbol);
                    }
                });
            }
        });
    }
}